import { type PaginatedSearchParams } from '../../Lib/Hooks/purchase-orders.hooks';
import { PurchaseOrderRevisionStatus } from '../../Lib/Types/purchase-order-revision';
import { StatusFilterGroup } from './types';

/**
 * Default search params for purchase orders
 *
 * @default is_cancelled = false
 */
export const defaultSearchParams: PaginatedSearchParams = {
  page: 0,
  size: 10,
  search: undefined,
  sort: undefined,
  filter: {
    sub_stages: undefined,
    is_cancelled: undefined,
    due_date: undefined,
    vendor_revision_status: undefined,
  },
  withPagination: true,
};

export const vendorRevisionRequestedStatus = [
  PurchaseOrderRevisionStatus.REVISION_REQUESTED,
  PurchaseOrderRevisionStatus.REVISION_NEGOTIATION,
];

export const startingFilters: StatusFilterGroup[] = [
  {
    items: [
      {
        label: 'Revision Requested',
        key: 'revision-requested',
        filters: {
          vendor_revision_status: vendorRevisionRequestedStatus,
        },
      },
    ],
  },
  {
    title: 'Bulk Production',
    items: [
      {
        label: 'Ready for Prod',
        key: 'ready-for-production',
        filters: {
          sub_stages: ['Ready for Production'],
        },
      },
      {
        label: 'Buy Materials',
        key: 'buy-materials',
        filters: {
          sub_stages: ['Buy Materials'],
        },
      },
      {
        label: 'Cutting/Sewing',
        key: 'cutting-sewing',
        filters: {
          sub_stages: ['Cutting/Sewing'],
        },
      },
      {
        label: 'Washing',
        key: 'washing',
        filters: {
          sub_stages: ['Washing'],
        },
      },
      {
        label: 'Packaging',
        key: 'packaging',
        filters: {
          sub_stages: ['Packaging'],
        },
      },
    ],
  },
  {
    title: 'TOP',
    items: [
      {
        label: 'Pending Samples',
        key: 'top-pending-samples',
        filters: {
          sub_stages: ['TOP: Sample Pending Receipt'],
        },
      },
      {
        label: 'Samples Shipped',
        key: 'top-samples-shipped',
        filters: {
          sub_stages: ['TOP: Shipped Samples'],
        },
      },
      {
        label: 'Partially Received',
        key: 'top-partially-received',
        filters: {
          sub_stages: ['TOP: Partially Received Samples'],
        },
      },
      {
        label: 'Pending Review',
        key: 'top-pending-review',
        filters: {
          sub_stages: ['TOP: Pending Review'],
        },
      },
      {
        label: 'Partially Approved',
        key: 'top-partially-approved',
        filters: {
          sub_stages: ['TOP: Partially Approved'],
        },
      },
      {
        label: 'Partially Rejected',
        key: 'top-partially-rejected',
        filters: {
          sub_stages: ['TOP: Partially Rejected'],
        },
      },
      {
        label: 'Rejected',
        key: 'top-rejected',
        filters: {
          sub_stages: ['TOP: Rejected'],
        },
      },
    ],
  },
  {
    title: 'Delivery & Shipping',
    items: [
      {
        label: 'Pending',
        key: 'delivery-pending',
        filters: {
          sub_stages: ['Delivery Date: Pending'],
        },
      },
      {
        label: 'Scheduled',
        key: 'delivery-scheduled',
        filters: {
          sub_stages: ['Delivery Date: Scheduled'],
        },
      },
    ],
  },
  {
    title: 'Receiving',
    items: [
      {
        label: 'Arrived at DC',
        key: 'receiving-arrived-dc',
        filters: {
          sub_stages: ['Receiving: Arrived at DC'],
        },
      },
      {
        label: 'Partially Received',
        key: 'receiving-partially-received',
        filters: {
          sub_stages: ['Receiving: Partially Received'],
        },
      },
    ],
  },
  {
    title: 'Payment',
    items: [
      {
        label: 'Payment Pending',
        key: 'payment-pending',
        filters: {
          sub_stages: ['Payment Pending'],
        },
      },
      {
        label: 'Fully Billed',
        key: 'payment-fully-billed',
        filters: {
          sub_stages: ['Fully Billed'],
        },
      },
    ],
  },
  {
    items: [
      {
        label: 'Cancelled',
        key: 'cancelled',
        filters: {
          is_cancelled: true,
        },
      },
    ],
  },
];
